import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import './unsubscription.scss';
import { UnsubscriptionComponent } from './unsubscription';
import { UnsubscriptionIndexModule } from './unsubscription-index/unsubscription-index.module';
import { ScaricaArchivioModule } from './scarica-archivio/scarica-archivio.module';
import { ScaricaDocumentiConservatiModule } from './scarica-documenti-conservati/scarica-documenti-conservati.module';
import { SubscriptionExpirationModule } from './subscription-expiration/subscription-expiration.module';
import { RenewSubscriptionModule } from './renew-subscription/renew-subscription.module';
import { RenewSubscriptionSummaryModule } from './renew-subscription-summary/renew-subscription-summary.module';


// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription', {
            url: '/unsubscription',
            'views': {
                'multiContent': {
                    template: '<unsubscription flex="100"></unsubscription>'
                }
            },
            abstract: true
        });
};

stateConfig.$inject = ['$stateProvider'];

export const UnsubscriptionModule: string = ng
    .module('unsubscription', [
        'ui.bootstrap',
        uiRouter,
        UnsubscriptionIndexModule,
        ScaricaArchivioModule,
        ScaricaDocumentiConservatiModule,
        SubscriptionExpirationModule,
        RenewSubscriptionModule,
        RenewSubscriptionSummaryModule
    ])
    .component('unsubscription', UnsubscriptionComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/unsubscription.module.ts